import { render } from "./NotFound.vue?vue&type=template&id=00125cb1"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=00125cb1&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__